module.exports = __webpack_public_path__ + "img/footer-video-bg.a4353f4a.jpg";